






























































































































































































































































import Vue, { PropType } from 'vue'
import { Learner } from 'vue/types/vue'
import Card from '@/components/atoms/Card.vue'
import GoldBadge from '@/assets/svgs/gold_badge.svg?inline'
import SilverBadge from '@/assets/svgs/silver_badge.svg?inline'
import BronzeBadge from '@/assets/svgs/bronze_badge.svg?inline'
import BookmarkIcon from '@/assets/svgs/bookmark_icon.svg?inline'

export default Vue.extend({
  name: 'LearnerInfo',
  props: {
    learner: Object as PropType<Learner>
  },
  components: {
    Card,
    GoldBadge,
    SilverBadge,
    BronzeBadge,
    BookmarkIcon
  },
  computed: {
    roundedSkillsMatch: function () {
      const learner: Learner = this.learner
      if (!learner.percentSkillsMatch) {
        return 0
      }
      return Math.round(learner.percentSkillsMatch)
    }
  }
})
